import { DropdownOption } from '@shared/interfaces/dev';

export const NATIONALITIES: DropdownOption<string>[] = [
  { label: 'Belge', value: 'Belge' },
  { label: 'Française', value: 'Française' },
  { label: 'Néerlandaise', value: 'Néerlandaise' },
  { label: 'Allemande', value: 'Allemande' },
] as const;
